import React from 'react';
import CommandList from '../CommandList';

function XCommand({ onCommandChange, onAddCommand }) {
    const commandItems = [

{ command: 'keyword', description: 'twitter_keyword_description', type: 'text' },
{ command: '""', description: 'twitter_""_description', type: 'text' },
{ command: '-', description: 'twitter_-_description', type: 'text' },
{ command: 'filter:links', description: 'twitter_filter_links_description', type: 'hidden', value: 'filter:links' },
{ command: 'filter:images', description: 'twitter_filter_images_description', type: 'hidden', value: 'filter:images' },
{ command: 'filter:videos', description: 'twitter_filter_videos_description', type: 'hidden', value: 'filter:videos' },
{ command: 'filter:verified', description: 'twitter_filter_verified_description', type: 'hidden', value: 'filter:verified' },
{ command: 'from:', description: 'twitter_from_description', type: 'text' },
{ command: 'to:', description: 'twitter_to_description', type: 'text' },
{ command: '@', description: 'twitter_mention_description', type: 'text' },
{ command: '#', description: 'twitter_hashtag_description', type: 'text' },
{ command: 'lang:', description: 'twitter_lang_description', type: 'text' },
{ command: 'since:', description: 'twitter_since_description', type: 'date' },
{ command: 'until:', description: 'twitter_until_description', type: 'date' },
    ];

    return <CommandList commandItems={commandItems} onCommandChange={onCommandChange} onAddCommand={onAddCommand} />;
}

export default XCommand;
